/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as Highcharts from 'highcharts';

/** Highcharts 12+ defaults are larger; keep axis labels closer to the pre-v12 look. */
const AXIS_LABEL_FONT_SIZE = '10px';

Highcharts.setOptions({
  xAxis: {
    labels: {
      style: {fontSize: AXIS_LABEL_FONT_SIZE}
    }
  },
  yAxis: {
    labels: {
      style: {fontSize: AXIS_LABEL_FONT_SIZE}
    },
    title: {
      style: {fontSize: '11px'}
    }
  },
  legend: {
    itemStyle: {fontSize: '12px'}
  },
  colorAxis: {
    labels: {
      style: {fontSize: AXIS_LABEL_FONT_SIZE}
    }
  }
});
